<template>
    <dashboard-layout tit="찜한 기업 관리" fullHeight>
        <template slot="contents">
            <!-- 찜한 기업 관리 리스트 -->
            <template v-if="items.length">
                <v-row class="row-cols-lg-5">
                    <v-col v-for="item in items" :key="item._id" cols="6">
                        <v-card rounded="lg" outlined class="applied-card" :href="`/companies/${item._userCompany}`">
                            <div class="pa-20 pa-md-24">
                                <v-img :aspect-ratio="166 / 36" width="100%" contain :src="item?.userCompany?.logo?.url">
                                    <v-fade-transition>
                                        <v-overlay v-show="!item?.userCompany?.logo?.url" absolute light color="white">
                                            <image-overlay>{{ item?.userCompany?.name }}</image-overlay>
                                            <!-- <v-layout row align-center class="black--text">
                                                <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                                <span> {{ item?.userCompany?.name }} </span>
                                            </v-layout> -->
                                        </v-overlay>
                                    </v-fade-transition>
                                </v-img>
                            </div>
                            <v-img :aspect-ratio="284 / 150" width="100%" cover :src="item?.userCompany?.introduction?.images?.[0]?.url">
                                <v-fade-transition>
                                    <v-overlay v-show="!item?.userCompany?.logo?.url" absolute light color="white">
                                        <v-layout row align-center class="black--text">
                                            <v-icon color="black" class="mr-4">mdi-domain</v-icon>
                                            <span> {{ item?.userCompany?.name }} </span>
                                        </v-layout>
                                    </v-overlay>
                                </v-fade-transition>
                            </v-img>
                            <div class="pa-20 pa-md-24">
                                <v-row align="center" class="row--small">
                                    <v-col>
                                        <p class="page-text--lg font-weight-medium">
                                            {{ item?.userCompany?.name }}
                                        </p>
                                    </v-col>
                                    <v-col cols="auto">
                                        <like-btn :params="{ _userCompany: item._userCompany, type: USER_LIKE_TYPES.USER_COMPNY.value }" @removed="remove(item)">
                                            <template #activator="{ active, toggle }">
                                                <v-btn icon small text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                                    <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                                </v-btn>
                                            </template>
                                        </like-btn>
                                    </v-col>
                                </v-row>
                                <!-- <span> {{ item?.userCompany?.name }} </span> <v-spacer />
                                <like-btn :params="{ _userCompany: item._userCompany, type: USER_LIKE_TYPES.USER_COMPNY.value }" @removed="remove(item)">
                                    <template #activator="{ active, toggle }">
                                        <v-btn icon small text :color="active ? 'yellow darken-1' : undefined" @click.stop.prevent.capture="toggle">
                                            <v-icon>{{ active ? "mdi-star" : "mdi-star-outline" }}</v-icon>
                                        </v-btn>
                                    </template>
                                </like-btn> -->
                            </div>
                        </v-card>
                    </v-col>
                </v-row>
                <v-pagination :value="page" :length="pageCount" :total-visible="11" color="primary" @input="(page) => $router.push({ query: { ...$route.query, page } })"></v-pagination>
            </template>
            <template v-else>
                <v-layout column justify-center align-center class="w-100 h-100 grey-f7 rounded-lg pa-20">
                    <p class="page-text--lg line-height-15 text-center mb-12 mb-lg-32">
                        안녕하세요, 사용자님. <br />
                        찜한 기업이 없습니다.
                    </p>
                    <v-btn href="/recruitments" text height="auto" color="transparent">
                        <span class="grey-9--text">채용공고 보러가기</span>
                    </v-btn>
                </v-layout>
            </template>
        </template>
    </dashboard-layout>
</template>

<script>
import api from "@/api";
import { USER_LIKE_TYPES } from "@/assets/variables";

import DashboardLayout from "@/components/dashboard/dashboard-layout.vue";
import LikeBtn from "@/components/client/like/like-btn.vue";
import RecruitmentViewApplication from "@/components/client/recruitments/view/recruitment-view-application.vue";
import ImageOverlay from "@/components/dumb/image-overlay.vue";

export default {
    components: {
        DashboardLayout,
        LikeBtn,
        RecruitmentViewApplication,
        ImageOverlay,
    },
    data: () => ({
        likes: [],

        limit: 10,
        summary: { totalCount: 0 },

        loading: false,
        USER_LIKE_TYPES,
    }),
    computed: {
        items() {
            return this.likes.map((item, index) => ({ ...item, index: this.summary.totalCount - (this.page - 1) * this.limit - index }));
        },
        page() {
            return +(this.$route.query.page || "1");
        },
        skip() {
            return (this.page - 1) * this.limit;
        },
        pageCount() {
            return Math.ceil(this.summary.totalCount / this.limit) || 1;
        },
        params() {
            let { ...query } = this.$route.query;
            return { ...query, type: USER_LIKE_TYPES.USER_COMPNY.value, withPopulate: true };
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        params() {
            this.search();
        },
    },
    methods: {
        init() {
            this.search();
        },
        async search() {
            this.loading = true;
            try {
                let { skip, limit, params } = this;
                var { summary, likes } = await api.v1.me.likes.gets({
                    headers: { skip, limit },
                    params,
                });

                this.likes = likes;
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        remove(item) {
            this.likes = this.likes.filter(({ _id }) => _id != item?._id);
        },
    },
};
</script>

<style></style>
